import React from 'react'
import { connect } from 'react-redux'
import Container from 'muicss/lib/react/container'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'
import Panel from 'muicss/lib/react/panel'
import Avatar from 'material-ui/Avatar'
import ListItem from 'material-ui/List/ListItem'
import FontAwesome from 'react-fontawesome'
import { acceptMission } from '../../../actions'
import MissionStartButton from './MissionStartButton'
import MissionDetail from './MissionDetail'
import MissionHistory from './MissionHistory'

const styles = {
  root: {
    padding: '0px',
  },
  header: {
    backgroundColor: '#F58A15',
    color: 'white',
    cursor: 'pointer',
  },
  headerImage: {
    height: '50px',
    width: 'auto',
  },
  description: {
    padding: '10px',
    paddingBottom: '50px',
  },
  experience: {
    backgroundColor: '#F58A15',
    textAlign: 'center',
    borderRight: '1px solid gray',
    color: '#fff',
    padding: '10px',
  },
  credits: {
    backgroundColor: '#F58A15',
    textAlign: 'center',
    borderLeft: '1px solid gray',
    color: '#fff',
    padding: '10px',
  },
  icons: {
    marginRight: '5px',
    fontSize: '16px',
  },
  name_icons: {
    marginLeft: '20px',
    color: 'white',
  },
  name: {
    marginLeft: '20px',
    marginBottom: '2px',
    color: 'white',
  },
  link: {
    display: 'flex',
  },
  linkBackground: {
    cursor: 'pointer',
    marginTop: '5px',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
}


class PreMissionShow extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      index: 0,
    }
  }

  icon = (icon, text, color) => (
    <Col xs="12" md="4" >
      <FontAwesome style={{ color }} name={icon} />
      { `\t${text}` }
    </Col>
  )

  showHistory = () => this.setState({ index: 1 })
  showDetails = () => this.setState({ index: 0 })

  body = () => ({
    0: <MissionDetail />,
    1: <MissionHistory back={() => this.showDetails()} />,
  }[this.state.index])

  render() {
    const { id, name, image_url } = this.props
    return (
      (id ?
        <div>
          <Panel style={styles.root}>
            <Container fluid >
              <Row style={styles.header} onClick={() => this.showHistory()}>
                <ListItem
                  style={styles.ListItem}
                  disabled
                  primaryText={
                    <div>
                      <div className="" style={styles.name}>
                        { name }
                      </div>
                      <Row className="" style={styles.name_icons}>
                        {this.icon('check', this.props.accepted_answers_count, 'green')}
                        {this.icon('clock-o', this.props.finished_answers_count, 'white')}
                        {this.icon('times', this.props.rejected_answers_count, 'red')}
                      </Row>
                    </div>
                  }
                  leftAvatar={
                    <Avatar size={60} src={image_url} />
                }
                />
              </Row>
              { this.body() }
            </Container>
          </Panel>
          <MissionStartButton
            missionState={this.props.state}
            handleClick={() => this.props.acceptMission(this.props)}
          />
          <div style={styles.linkBackground}>
            {
              this.state.index === 0
              ? (
                <a style={styles.link} onClick={() => this.showHistory()}>
                  Ver Historial
                </a>
              )
              : (
                <a style={styles.link} onClick={() => this.showDetails()}>
                  Volver
                </a>
              )
            }
          </div>
        </div>
      : <div />)
    )
  }
}

PreMissionShow.propTypes = {
  id: React.PropTypes.number,
  name: React.PropTypes.string,
  image_url: React.PropTypes.string,
  state: React.PropTypes.number,
  acceptMission: React.PropTypes.func.isRequired,
  accepted_answers_count: React.PropTypes.number,
  finished_answers_count: React.PropTypes.number,
  rejected_answers_count: React.PropTypes.number,
}

const mapStateToProps = state => ({
  ...state.missions.selectedMission,
})

const mapDispatchToProps = dispatch => ({
  acceptMission: id => dispatch(acceptMission(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PreMissionShow)



// WEBPACK FOOTER //
// ./src/components/CampaignShow/PreMissionShow/index.jsx